import TRAVELLER_TYPES from 'modules/trip/traveller-types';

const TITLE_NOT_SELECTED = '---';
export const DEFAULT_FFN_OPTION = {
    text: '- Select Frequent Flyer Number -',
    value: '',
};

export default function TripTravellerAllocationPassengerService(
    selectedSeatsService,
    l10nService,
) {
    'ngInject';

    Object.assign(this, {
        getInfantThisPassengerTravellingWith,
        getTravellerNameWithoutTitle,
        getTravellerOrderNumberAmongAll,
        getTravellerFullName,
        getFFNsListForDropdown,
        areFFNsProvided,
        preSelectFFN,
        isChild,
    });

    function getInfantThisPassengerTravellingWith(traveller, tripDetails) {
        const isValid = traveller && traveller.Id
            && tripDetails && tripDetails.Travelers
            && tripDetails.Travelers.Infant
            && tripDetails.Travelers.Infant.length;

        if (!isValid) {
            return null;
        }

        const infants = tripDetails.Travelers.Infant;
        return infants.find(({AdultTripPassengerId: adultId}) => adultId === traveller.Id)
            || null;
    }

    function getTravellerFullName(traveller) { // eslint-disable-line
        const DEFAULT_VALUE = '';
        if (!traveller) {
            return DEFAULT_VALUE;
        }

        const titleText = traveller.Title && traveller.Title.text
            || traveller.Title
            || DEFAULT_VALUE;
        const title = titleText === TITLE_NOT_SELECTED ? DEFAULT_VALUE : titleText;

        const fullName = [
            title,
            traveller.FirstName || DEFAULT_VALUE,
            traveller.MiddleName || DEFAULT_VALUE,
            traveller.LastName || DEFAULT_VALUE,
        ];

        return fullName
            .filter((value) => !!value)
            .join(' ');
    }

    function getTravellerNameWithoutTitle(traveller) {
        const DEFAULT_VALUE = '';
        if (!traveller) {
            return DEFAULT_VALUE;
        }

        const fullName = [
            traveller.FirstName || DEFAULT_VALUE,
            traveller.MiddleName || DEFAULT_VALUE,
            traveller.LastName || DEFAULT_VALUE,
        ];

        return fullName
            .filter((value) => !!value)
            .join(' ');
    }

    function getTravellerOrderNumberAmongAll(traveller, travellers) {
        const foundTraveller = travellers.find(({Id}) => Id === traveller.Id);
        return foundTraveller
            && travellers.indexOf(foundTraveller) + 1
            || null;
    }

    function getFFNsListForDropdown(traveller) {
        if (!(traveller && traveller.ClubCards)) {
            return [];
        }

        const options = traveller.ClubCards
            .map((clubCard) => ({
                text: `${clubCard.Ffn} (${clubCard.SupplierName})`,
                value: clubCard.Ffn,
                raw: clubCard,
            }));

        return [
            ...getLocalizedDefaultFfnOption(),
            ...options,
        ];
    }

    function areFFNsProvided(traveller) {
        return !!(traveller
            && traveller.ClubCards
            && traveller.ClubCards.length);
    }

    function preSelectFFN(ffnOptions, flight, traveller, selectedSeats) {
        const selectedClubCardId = selectedSeatsService.getSelectedFFN(traveller, flight, selectedSeats);

        if (selectedClubCardId) {
            const ffnOption = ffnOptions.find((option) => option.raw && option.raw.Id === selectedClubCardId);
            if (ffnOption) {
                return ffnOption;
            }
        }

        return ffnOptions.find((ffnOption) =>
                (ffnOption.raw && ffnOption.raw.SupplierCode === flight.MarketingAirlineCode))
            || getLocalizedDefaultFfnOption();
    }

    function isChild(traveller) {
        return traveller
            && traveller.PassengerType === TRAVELLER_TYPES.CHILD;
    }

    function getLocalizedDefaultFfnOption() {
        return {text: l10nService.localize(DEFAULT_FFN_OPTION.text), value: DEFAULT_FFN_OPTION.value};
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/checkout/trip-traveller-allocation/trip-traveller-allocation-segment/trip-traveller-allocation-flight/trip-traveller-allocation-passenger/trip-traveller-allocation-passenger-service.js